export function Header() {
  return (
    <header className="sticky top-0 z-10 bg-white/90 backdrop-blur-md border-b border-gray-250/70 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo and title */}
          <a href="/" className="flex items-center space-x-3 group cursor-pointer hover:opacity-95 transition-opacity">
            <div className="w-8 h-8 bg-gradient-to-tr from-blue-600 to-indigo-650 rounded-lg flex items-center justify-center shadow-md shadow-blue-600/10 group-hover:scale-105 transition-transform">
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                />
              </svg>
            </div>
            <div>
              <h1 className="text-lg font-extrabold text-gray-900 tracking-tight">
                WaySight<span className="text-blue-600">AI</span>
              </h1>
              <p className="text-[10px] font-semibold text-gray-500">Privacy-First Forecasting</p>
            </div>
          </a>

          {/* Navigation and user info */}
          <div className="flex items-center space-x-6">
            {/* Privacy indicator badge */}
            <div className="hidden items-center space-x-1.5 text-xs font-semibold text-emerald-700 bg-emerald-50/80 px-3 py-1.5 rounded-full border border-emerald-200/50 sm:flex">
              <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span>
              <span>100% Browser-Local Processing</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
